function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".new_window__icon" + shadowSelector + " {--axds-ovr-icon-color: var(--sds-g-color-palette-blue-50);}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];